export default __webpack_public_path__ + "static/media/tete30.d86cd303.png";